<!-- 发起人、审核人、抄送人、条件展示页面 -->
<template>
    <div>
        <!-- 发起人、审核人、抄送人 -->
        <div class="node-wrap" v-if="nodeConfig.setType<5">
            <div class="node-wrap-box" :class="(nodeConfig.setType==2?'start-node ':'')+(isTried&&nodeConfig.error?'active error':'')">
                <div>
                    <div class="title" :style="`background: rgb(${bgColor});`">
                        <!-- 发起人 -->
                        <span v-if="nodeConfig.setType==2">{{nodeConfig.nodeName}}</span>
                        <!-- 审批人、抄送人 -->
                        <template v-else>
                            <span class="title-text-ellipsis">
                                <i :class="nodeConfig.setType==3?'el-icon-user-solid':'el-icon-s-promotion'"></i>
                                {{nodeConfig.nodeName}}
                            </span>
                            <!-- hover出现删除图标 -->
                            <i class="anticon anticon-close close" @click="delNode"></i>
                        </template>
                    </div>
                    <div class="content" @click="setPerson(nodeConfig)">
                        <div class="text">
                            {{ showText }}
                        </div>
                        <i class="anticon anticon-right arrow"></i>
                    </div>

                </div>
            </div>
            <!-- 添加节点组件 -->
            <addNode :childNodeP.sync="nodeConfig.childNode"></addNode>
        </div>
        <!-- 路由 -->
        <div class="branch-wrap" v-if="nodeConfig.setType==6">
            <div class="branch-box-wrap">
                <div class="branch-box">
                    <button class="add-branch" @click="addTerm">添加条件</button>
                    <!-- 条件分支 -->
                    <div class="col-box" v-for="(item,index) in nodeConfig.conditionNodes" :key="index">
                        <div class="condition-node">
                            <div class="condition-node-box">
                                <div class="auto-judge" :class="isTried&&item.error?'error active':''">
                                    <!-- < -->
                                    <div class="sort-left" v-show="item.isDefault!=1" v-if="index!=0" @click="arrTransfer(index,-1)">&lt;</div>
                                    <!-- 条件分支title -->
                                    <div class="title-wrapper">
                                        <span class="editable-title">{{item.nodeName}}</span>
                                        <span class="priority-title" @click="item.isDefault!=1?setPerson(item):null">优先级{{item.priorityLevel}}</span>
                                        <!-- hover出现删除图标 -->
                                        <i v-show="item.isDefault!=1" class="el-icon-close anticon anticon-close close" @click="delTerm(index)"></i>
                                    </div>
                                    <!-- > -->
                                    <div class="sort-right" v-if="index!=nodeConfig.conditionNodes.length-1" @click="arrTransfer(index)">&gt;</div>
                                    <!-- 条件内容展示 -->
                                    <div class="content" @click="item.isDefault!=1?setPerson(item):null">{{conditionStr(nodeConfig,index)}}</div>

                                </div>
                                <!-- 继续展示条件下的childNode -->
                                <addNode :childNodeP.sync="item.childNode"></addNode>
                            </div>
                        </div>

                        <!-- 循环展示其他流程 -->
                        <nodeWrap v-if="item.childNode" :nodeConfig.sync="item.childNode" @clickApproveNode=setPerson></nodeWrap>
                        <template v-if="index==0">
                            <div class="top-left-cover-line"></div>
                            <div class="bottom-left-cover-line"></div>
                        </template>
                        <template v-if="index==nodeConfig.conditionNodes.length-1">
                            <div class="top-right-cover-line"></div>
                            <div class="bottom-right-cover-line"></div>
                        </template>

                    </div>
                </div>

                <!-- 添加节点 -->
                <addNode :childNodeP.sync="nodeConfig.childNode"></addNode>
            </div>
        </div>

        <!-- 继续展示除第一级的其他流程 -->
        <nodeWrap v-if="nodeConfig.childNode" :nodeConfig.sync="nodeConfig.childNode" @clickApproveNode=setPerson></nodeWrap>

    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { v4 as uuidv4 } from 'uuid';

export default {
    // nodeConfig参数，在three.vue中获取到
    props: ["nodeConfig"],
    data() {
        return {
            userTypeArr: [
                { id: '1', name: '指定用户' },
                { id: '2', name: '发起人自选' },
                { id: '3', name: '发起人自己' },
                { id: '4', name: '指定角色' },
                { id: '5', name: '发起人部门负责人' },
                { id: '6', name: '发起人直属领导' },
                { id: '7', name: '连续多级部门的负责人' },
                { id: '20', name: '部门的成员（包括负责人）' },
                { id: '22', name: '岗位' },
                { id: '23', name: '连续多级部门的负责人' },
                { id: '40', name: '用户组' },
                { id: '50', name: '表单内用户字段' },
                { id: '51', name: '表单内部门负责人' },
                { id: '60', name: '流程表达式' },
                { id: '100', name: '项目经理人' },
                { id: '0', name: '审批人为空' }
            ],
        }
    },
    mounted() {
        console.log('nodeWrap页面返回的数据：')
        console.log(this.nodeConfig)
    },
    computed: {
        ...mapState('flow', ['isTried', 'flowPermission1', 'approverConfig1', 'copyerConfig1', 'conditionsConfig1']),//暂时没用到
        // 流程节点title颜色
        bgColor() {
            return ['87, 106, 149', '255, 148, 62', '50, 150, 250'][this.nodeConfig.setType - 2]
        },
        // 流程节点body展示内容
        showText() {
            if (this.nodeConfig.nodeUserList.length > 0) {
                return this.nodeConfig.nodeUserList.map(item => item.name).toString()
            }
            else {
                let candidateStrategy = String(this.nodeConfig.candidateStrategy);
                if (candidateStrategy == '1' || candidateStrategy == '4') {
                    return '请设置人员'
                } else {
                    const found = this.userTypeArr.find(item => item.id === candidateStrategy);
                    return found ? found.name : '请设置人员';
                }
            }
        },


    },
    watch: {

    },
    methods: {
        ...mapMutations([
            'setPromoter',
            'setApprover',
            'setCopyer',
            'setCondition',
            'setFlowPermission',
            'setApproverConfig',
            'setCopyerConfig',
            'setConditionsConfig'
        ]),
        // 条件展示内容
        conditionStr(nodeConfig, index) {
            let node = nodeConfig.conditionNodes[index];
            if (node.isDefault == 1 && node.setType == 5) {
                return '所有条件都不满足进入此流程'
            }
            var { conditionGroups, nodeUserList } = node;
            if (conditionGroups.length == 0) {//目前有个默认,type=0
                return '请设置条件'
            } else {
                //拼接条件节点配置的条件内容展示文本
                const conditionText = conditionGroups[0].conditionRules?.map(rule => {
                    if (rule.type == 0) {
                        return `[发起人-属于-(${rule.startUserList.map(u => u.name).join(',')})]`
                    }
                    const { formVariableCondition } = rule;
                    if (formVariableCondition) {
                        const { variableName, operatorLabel, valueLabel, value } = formVariableCondition;
                        return `[${variableName}-${operatorLabel}-(${valueLabel || value})]`;
                    }
                    return '';
                }).filter(text => text).join('；');
                let str = conditionText || "条件组数量:" + conditionGroups.length
                return str ? str : '请设置条件'
            }
        },

        // 发起人、审核人、抄送人 删掉节点
        delNode() {
            // 向父组件发送自定义事件，并传递数据给父组件。父组件可以通过监听这个自定义事件来执行相应的逻辑
            this.$emit("update:nodeConfig", this.nodeConfig.childNode);
            console.log(this.nodeConfig)
        },
        // 添加条件
        addTerm() {
            let len = this.nodeConfig.conditionNodes.length + 1
            let item = {
                "nodeName": "条件" + len,
                "type": 5,
                "setType": 5,
                "isDefault": 0,
                "candidateStrategy": '',
                "priorityLevel": len,
                "conditionGroups": [
                ],
                "nodeUserList": [],
                "childNode": null
            };
            let defaultItem = this.nodeConfig.conditionNodes.find(i => i.isDefault == 1)
            const defaultIndex = this.nodeConfig.conditionNodes.findIndex(i => i.isDefault == 1);
            if (defaultIndex === -1) {
                this.nodeConfig.conditionNodes.push(item);
            } else {
                item.priorityLevel = defaultItem.priorityLevel;
                item.nodeName = "条件" + item.priorityLevel;
                defaultItem.priorityLevel = len;
                this.nodeConfig.conditionNodes.splice(defaultIndex, 0, item);
            }

            // this.resetConditionNodesErr()
            this.$emit("update:nodeConfig", this.nodeConfig);
        },
        // 条件1 >
        arrTransfer(index, type = 1) {//向左-1,向右1
            let conditionNode = this.nodeConfig.conditionNodes[index + type];
            if (conditionNode.isDefault == 1) {
                this.$message.error("默认条件不能移动")
                return
            }
            this.nodeConfig.conditionNodes[index] = this.nodeConfig.conditionNodes.splice(index + type, 1, this.nodeConfig.conditionNodes[index])[0];
            this.nodeConfig.conditionNodes.map((item, index) => {
                item.priorityLevel = index + 1
            })
            this.$emit("update:nodeConfig", this.nodeConfig);
        },
        // 删除条件
        delTerm(index) {
            this.nodeConfig.conditionNodes.splice(index, 1)
            this.nodeConfig.conditionNodes.map((item, index) => {
                if (item.isDefault != 1) {
                    item.nodeName = `条件${index + 1}`
                }
                item.priorityLevel = index + 1
            });
            // this.resetConditionNodesErr()
            this.$emit("update:nodeConfig", this.nodeConfig);
            if (this.nodeConfig.conditionNodes.length == 1) {
                this.nodeConfig.conditionNodes = []
                this.$emit("update:nodeConfig", this.nodeConfig.childNode);
                // if (this.nodeConfig.childNode) {
                //     if (this.nodeConfig.conditionNodes[0].childNode) {
                //         this.reData(this.nodeConfig.conditionNodes[0].childNode, this.nodeConfig.childNode)
                //     } else {
                //         this.nodeConfig.conditionNodes[0].childNode = this.nodeConfig.childNode
                //     }
                // }
                // this.$emit("update:nodeConfig", this.nodeConfig.conditionNodes[0].childNode);
            }
        },
        reData(data, addData) {
            if (!data.childNode) {
                data.childNode = addData
            } else {
                this.reData(data.childNode, addData)
            }
        },
        resetConditionNodesErr() {

        },
        // 点击卡片打开右边抽屉
        setPerson(item) {
            var { setType } = item;// 0 发起人 1审批 2抄送 3条件 4路由
            if (setType == 0) {
                // 打开发起人抽屉
                //this.setPromoter(true)
            }
            this.$emit("clickApproveNode", item);
        },
    }
}
</script>
<style scoped>
.title-text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>